import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "flex flex-col h-full w-[25rem] items-center justify-center text-light-black mb-14" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-8/12" }, "Create a workbean account", -1)
const _hoisted_4 = { class: "w-full align-middle mt-5 flex flex-col gap-6 bg-white shadow-base h-fit rounded-t-3xl px-5 py-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex mt-2 w-full justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "googleButton" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bg-light-gray-100 w-full flex justify-center items-center py-5 rounded-b-3xl" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Already on Workbean? "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-primary-violet font-bold",
      href: "/login"
    }, "Login")
  ])
], -1)

import { onMounted } from "vue"
  import { IonNavLink, IonButton } from "@ionic/vue"
  import { person } from "ionicons/icons"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useGtm } from "@gtm-support/vue-gtm"
  import * as jwt from "@/utils/jwt"

  import SignupPage from "@/views/SignupPage.vue"
  import WbTemplate from "@/components/account-creation/template.vue"
  import Menubar from "@/components/menuBar.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SignAs',
  setup(__props) {

  const authenticationStore = useAuthenticationStore()
  const gtm = useGtm()

  /**
   * @param response  = token received from google
   *
   * parses received token and assign to authentication store credentials
   */
  const handleCredentialResponse = ({ credential }: { credential: any }) => {
    const responsePayload = credential
    const googleCredentials = verifyToken(responsePayload)
    const payload = {
      email: googleCredentials.email,
      email_verified: googleCredentials.email_verified,
      last_name: googleCredentials.family_name,
      first_name: googleCredentials.given_name,
      full_name: googleCredentials.name,
      photo: googleCredentials.picture || "",
    }
    authenticationStore.loginDetails.google_token = jwt.default.generateToken(payload, jwt.default.generateNBF())
    authenticationStore.login(jwt.default.generateNBF(), undefined, gtm, googleCredentials.email)
  }

  // initializes google api for google button
  const googleInit = () => {
    // eslint-disable-next-line no-undef
    google.accounts?.id.initialize({
      client_id: "779082346605-6f9d8to1hni6bjajmtpi3a8146lm1lkn.apps.googleusercontent.com",
      callback: handleCredentialResponse,
      context: "signin",
      ux_mode: "popup",
      close_on_tap_outside: "false",
      auto_select: "true",
      auto_prompt: "false",
    })
    // eslint-disable-next-line no-undef
    google.accounts?.id.renderButton(
      document.getElementById("googleButton"),
      { size: "large", logo_alignment: "center" } // customization attributes
    )
  }

  /**
   *
   * @param response  - google jwt
   * parses the payload of  google jwt
   */
  const verifyToken = (response: string) => {
    try {
      const parsed = JSON.parse(atob(response.split(".")[1]))
      return parsed
    } catch (e) {
      return null
    }
  }

  onMounted(() => {
    googleInit()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Menubar)
    ]),
    _createVNode(WbTemplate, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonNavLink), {
              "router-direction": "forward",
              component: SignupPage
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  color: "white",
                  class: "text-primary-black font-bold rounded-base shadow-base"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _unref(person) }, null, 8, ["icon"]),
                    _createTextVNode("Use email")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_5,
            _hoisted_6
          ]),
          _hoisted_7
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})